import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import ContentBox from '../../../molecules/ContentBox';
import ModalComponent from '../../../organisms/ModalComponent';
import administratorStore from '../../../../stores/administratorStore';
import AutocompleteComponent from '../../../atoms/AutocompleteComponent';
import { Button, Space, Table, TableColumnsType, TableProps, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { DEFAULT_PAGE_SIZE } from '../../../../config/config';
import { formatDocument } from '../../../../utils/TextFormatters';
import { getStatusColor } from '../../../../utils/statusColorMapper';
import { removeSpecialCharacters } from '../../../../utils/functions';

interface AddCustomerProps {
    administrator: any;
}

interface DataType {
    [x: string]: any;
    displayUnits: any;
    baseQty: string;
    name: string;
    uuid: any;
    key: React.Key;
}

const defaultparams = {
    size: 20,
    page: 0,
    sort: 'created,desc',
    search: '',
}

const AddCustomer: React.FC<AddCustomerProps> = observer(({ administrator }) => {
    const [autocompleteOptions, setAutocompleteOptions] = useState<any>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>([]);
    const { childCustomer, page, size, totalElements, loadingChild } = administratorStore;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemSelected, setItemSelected] = useState<any>();

    useEffect(() => {
        if (administrator !== null) {
            administratorStore.getChildCustomer(administrator?.uuid, defaultparams);
        }
    }, [administrator])

    const handleSearch = async (searchText: string) => {
        setAutocompleteOptions([]);
        if (searchText.length > 3) {
            try {
                const response = await administratorStore.getChildCustomerByTerm(removeSpecialCharacters(searchText));
                setAutocompleteOptions(response);
                // Aqui você pode mapear a resposta para opções, se necessário
            } catch (error) {
                console.error('Erro ao buscar cliente:', error);
            }
        }
    };


    const onChange: TableProps<DataType>['onChange'] = async (pagination, filters, sorter, extra) => {
        const params = buildParams(pagination);
        await administratorStore.getChildCustomer(administrator.uuid, params);
    };

    const buildParams = (
        pagination: any,
    ) => {
        const currentPage = pagination.current - 1;
        const newPageSize = pagination.pageSize || DEFAULT_PAGE_SIZE;

        const params = {
            size: pagination.pageSize || newPageSize,
            page: pagination.current ? currentPage : 0,
        };

        return params;
    };


    // Validar
    const addProduct = () => {
        if (selectedProduct.option) {
            administratorStore.addChildCustomerAction(selectedProduct.option);
        }
    }

    const columns: TableColumnsType<DataType> = [
        {
            title: 'Nome',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Documento',
            dataIndex: 'document',
            key: 'document',
            render: (text) => {
                return (
                    <>{<p>{formatDocument(text)}</p>}</>
                );
            },
        },
        {
            title: 'Ativos',
            dataIndex: 'active',
            key: 'active',
            sorter: true,
            filters: [
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false },
            ],
            render: (active) => {
                let text = active ? 'Ativo' : 'Inativo';
                return (
                    <Tag color={getStatusColor(text)}><p>{text}</p></Tag>
                );
            },
        },
        {
            title: 'Deletar',
            dataIndex: 'delete',
            key: 'delete',
            align: 'center',
            width: 80,
            render: (text, record) => (
                <Space className="cursor-pointer" onClick={() => showModal(record)}>
                    <div ><DeleteOutlined /></div>
                </Space>
            ),
        },
    ];

    const showModal = (record: any) => {
        setItemSelected(record);
        setIsModalOpen(true);
    };

    const handleDeleteItem = () => {
        administratorStore.removeChildCustomer(itemSelected);
        setIsModalOpen(false);
    };

    return (
        <>
            <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Adicionar Cliente" description='Adicionar cliente Associado'>
                <div className="flex pt-3 gap-4 items-end">
                    <AutocompleteComponent
                        label="Buscar Cliente (Documento)"
                        name="searchTermCustomer"
                        placeholder="Digite o Documento"
                        fetchOptions={handleSearch}
                        options={autocompleteOptions}
                        onChange={(value: any) => setSelectedProduct(value)}
                    />
                    <Button type='primary' onClick={() => addProduct()}>Adicionar</Button>
                    {/* <FileUpload onFileProcessed={handleFileProcessed} requiredColumns={['SKU']} />
                    <ActionButton icon actionType="export" onClick={() => handleExport()}>Baixar Planilha</ActionButton> */}
                </div>


                <div className="mt-4">
                    <Table
                        className="table-custom"
                        columns={columns}
                        dataSource={childCustomer?.map((item: any, index: number) => ({
                            ...item,
                            key: item.uuid || index,
                        }))}
                        loading={loadingChild}
                        onChange={onChange}
                        size="middle"
                        bordered={false}
                        pagination={{
                            current: page + 1,
                            pageSize: size,
                            total: totalElements,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '40', '60'],
                        }}
                    />
                </div>
            </ContentBox>

            {isModalOpen && <ModalComponent
                title="Aviso"
                content={<p>Você deseja excluir o Cliente <b>{itemSelected?.firstName}</b>?</p>}
                isModalOpen={isModalOpen}
                handleOk={handleDeleteItem}
                handleCancel={() => setIsModalOpen(false)}
            />}
        </>
    );
});

export default AddCustomer;
